import React from "react";
// icon
// import { BsArrowUpRight } from "react-icons/bs";
// motion
import { motion } from "framer-motion";
// variants
import { fadeIn } from "../variants";
// service data
const services = [
  {
    name: "UI/UX Design",
    description:
      "As a UI/UX designer Fresher, I have honed my skills in creating intuitive and visually appealing user interfaces..",
    // link: "Learn More",
  },
  {
    name: "Developer",
    description:
      "As a developer Fresher , I have gained valuable skills in software development and coding.",
    // link: "Learn More",
  },
  {
    name: "Designer",
    description:
      "As a designer with 6 months experience, I have cultivated a keen eye for aesthetics and a deep understanding of design principles.",
    // link: "Learn More",
  },
  {
    name: "Digital Marketing",
    description:
      "As a digital marketer with experience working with Forever Club, Bizquesta, and Bizgurukul, I have developed a comprehensive skill set in driving successful marketing campaigns.",
    // link: "Learn More",
  },
];
const Services = () => {
  return (
    <section className="section" id="services">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">
          {/* text  and images */}
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            // className="flex-1 lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0"
          >
            <h2 className="h2 text-accent mb-6">What I Do.</h2>
            <h3 className="h3 max-w-[450px] mb-16">
              I'm a Freelance Front-end Developer Fresher
            </h3>
            {/* <button className="btn btn-sm">See My Work</button> */}
          </motion.div>
          {/* services */}
          <motion.div
            variants={fadeIn("left", 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1"
          >
            {/* service list */}
            <div>
              {services.map((service, index) => {
                // destructure service
                const { name, description, link } = service;
                return (
                  <div
                    className="border-b border-white/20 h-[146px] mb-[38px] flex"
                    key={index}
                  >
                    <div className="max-w-[476px]">
                      <h4 className="text-[20px] tracking-wider font-primary font-semibold mb-6">
                        {name}
                      </h4>
                      <p className="font-secondary leading-tight">
                        {description}
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 items-end">
                      <a href="#" className="text-gradient text-sm">
                        {link}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
